import React from 'react';
import { observer } from 'mobx-react'; // Import the observer HOC
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Avatar,
  Box
} from '@chakra-ui/react';
import { bookingFlowStore } from '../store/BookingFlowStore';

interface Doctor {
  display_name: string;
  about: string;
  image: string;
  gender: string;
  qualifications?: string;
}

interface DoctorDetailsProps {
  doctor: Doctor;
  isOpen: boolean;
  onClose: () => void;
}

// Wrap the component with observer
const DoctorDetails: React.FC<DoctorDetailsProps> = observer(({ doctor, isOpen, onClose }) => {

  const makeAppointment = () => {
    bookingFlowStore.updateAppointmentData("selectedDoctor", doctor);
    bookingFlowStore.setIsModalOpen(true);
  };

  const mapStringToValue = (input: string) => {
    switch (input) {
      case 'F': return 'Female';
      case 'M': return 'Male';
      default: return input;
    }
  };

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} size="md" blockScrollOnMount={false}>
        <DrawerOverlay />
        <DrawerContent display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <DrawerCloseButton />
          <DrawerHeader>Doctor Details</DrawerHeader>
          <DrawerBody>
            <Box alignItems="center" justifyContent="center" textAlign="center" mb="10px">
              <Avatar name={doctor.display_name} size="xl" src={doctor.image} style={{ boxShadow: "5px 5px 5px gray" }} />
              <Text fontWeight="bold" fontSize="xl" mt="10px">
                {doctor.display_name}
              </Text>
              <Text fontSize="sm" fontWeight="bold">{mapStringToValue(doctor.gender)}</Text>
              <p style={{ fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: doctor.about }} />
              <Text fontSize="sm" color="gray.500">{doctor.qualifications}</Text>
            </Box>

            <Button onClick={makeAppointment} mt={8} width="100%" fontSize="small" bg="#B92F2F" color="#fff" variant="solid" borderRadius="30px">
              Book Appointment
            </Button>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
});

export default DoctorDetails;